import { AvatarProfile } from "components/AvatarProfile";
import { LogoProps } from "components/ProductsLogos";
import { useBreakpoints } from "hooks/useBreakpoints";
import React from "react";

interface QuoteProps {
  name: string;
  company: string;
  image: string;
  quote: string | JSX.Element;
  products: React.FunctionComponent<LogoProps>[];
}

export const Quote = ({
  quote,
  name,
  image,
  company,
  products,
}: QuoteProps) => {
  const { isMediumWidth } = useBreakpoints();

  return (
    <div className="flex flex-col gap-24 rounded-[12px] bg-white px-28 py-24 shadow-a dark:bg-[#171717] dark:shadow-none md:bg-transparent md:py-0 md:shadow-none md:dark:bg-transparent lg:px-40">
      <h4 className="mx-auto max-w-[48ch] text-center text-14-22 text-gray-700 dark:text-gray-500 md:max-w-none md:text-left md:text-18-28">
        &ldquo;{quote}&rdquo;
      </h4>
      <div className="flex flex-col items-center justify-between gap-24 md:items-start lg:flex-row lg:items-center">
        <AvatarProfile
          name={name}
          image={image}
          company={company}
          wide={!isMediumWidth}
        />
        <div className="justify-cnter flex flex-wrap items-center gap-6 text-gray-500 dark:text-gray-700 lg:gap-x-12">
          {products.map((Product, i) => {
            return (
              <React.Fragment key={i}>
                {i > 0 && (
                  <span className="text-gray-500 dark:text-gray-700">+</span>
                )}
                <Product size={20} key={Product.displayName} />
              </React.Fragment>
            );
          })}
        </div>
      </div>
    </div>
  );
};
